import { Action, ThunkDispatch } from '@reduxjs/toolkit';

import { EntityType } from '@frontend/common';
import { ScheduleClient } from '@frontend/report/api';
import { useResolver } from '@frontend/repository';
import React from 'react';

declare global {
    interface WindowEventMap {
        'useSchedule:request': CustomEvent<string>;
    }
}

const REQUEST_SCHEDULE_EVENT = 'useSchedule:request';
const STORAGE_KEY = 'SCHEDULE_REQ';

export function scheduleRequest(scheduleId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_SCHEDULE_EVENT, { detail: scheduleId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

export function ScheduleResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_SCHEDULE_EVENT, EntityType.SCHEDULE, (ids) => ScheduleClient.resolveSchedules(ids), props.dispatch);
    return <></>;
}